<div class="detail-address-container">
  <mat-card fxFlex="100" >
    <h3>{{header}}</h3>

    <div fxLayout="column" fxLayoutGap="15px">
      <div fxLayout="row" fxLayoutGap="15px">
        <app-detail fxFlex="50" header="Ulica" [value]="address.street"></app-detail>
        <div fxFlex="50" fxLayout="row" fxLayoutGap="15px">
          <app-detail fxFlex="50" header="Nr budynku" [value]="address.houseNumber"></app-detail>
          <app-detail fxFlex="50" header="Nr lokalu" [value]="address.apartmentNumber"></app-detail>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <app-detail *ngIf="address.postCity" fxFlex="50" header="Poczta" [value]="address.postCity"></app-detail>
        <app-detail *ngIf="!address.postCity" fxFlex="50" header="Miejscowość" [value]="address.city"></app-detail>
        <app-detail fxFlex="50" header="Kod pocztowy" [value]="address.zipCode"></app-detail>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="address.state">
        <app-detail *ngIf="address.postCity" fxFlex="50" header="Miejscowość" [value]="address.city"></app-detail>
        <app-detail [fxFlex]="address.postCity ? '50' : '100'" header="Województwo" [value]="address.state?.name"></app-detail>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="address.district || address.commune">
        <app-detail fxFlex="50" header="Powiat" [value]="address.district"></app-detail>
        <app-detail fxFlex="50" header="Gmina" [value]="address.commune"></app-detail>
      </div>
    </div>
  </mat-card>
</div>
